import React, { Fragment } from 'react'
import Radio, { RadioProps } from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormControl from '@material-ui/core/FormControl'
import { FormHelperText, withStyles, Typography } from '@material-ui/core'
import { MyRadioViewProps, RadioCtrlProps } from './radioType'
import useRadio from './useRadio'
import { makeStyles, useTheme } from '@material-ui/core/styles'
import Tooltip from '../tooltip/tooltip'
import InfoIcon from '@material-ui/icons/Info'
import IconButton from '@material-ui/core/IconButton'

// const theme = createMuiTheme({
//     palette: {
//         primary: {
//             main: '#ff7f50',
//         },
//     },
//     typography: {
//         fontFamily: 'Prompt, sans-serif',
//     },
//     overrides: {
//         MuiFormLabel: {
//             root: {
//                 fontSize: '18px',
//                 color: '#bfbfbf',
//                 '&$focused': {
//                     color: '#ff7f50',
//                 },
//                 '&$error': {
//                     color: ' #ff4d4f',
//                 },
//                 '&$disabled': {
//                     color: '#e0e0e0',
//                 },
//             },
//         },
//     },
// })

const ErrorRadio = withStyles({
    root: {
        color: '#d50000',
        '&$checked': {
            color: '#d50000',
        },
    },
    checked: {},
})((props: RadioProps) => <Radio color="default" {...props} />)

let MyRadioView: React.FC<MyRadioViewProps> = ({
    labelGroup,
    options = [],
    field,
    required,
    requiredHalfWidth,
    disabled,
    onChangeValue,
    tooltipLabel,
    tooltipPlacement = 'bottom',
}) => {
    const { input, meta } = field
    const isError = meta.error && meta.invalid && meta.touched ? true : false
    const classes = useStyles(isError)
    const theme = useTheme()
    const getLabel = () => {
        return (
            <Typography variant={'subtitle2'} className={classes.label}>
                {labelGroup || ''} {required && <label style={{ color: 'red' }}>{labelGroup ? `*` : ''}</label>}
                {tooltipLabel && tooltipLabel !== '' && (
                    <Tooltip title={tooltipLabel} placement={tooltipPlacement}>
                        <IconButton size="small">
                            <InfoIcon style={{ color: theme.palette.info.main }} />
                        </IconButton>
                    </Tooltip>
                )}
            </Typography>
        )
    }

    return (
        <FormControl style={{ width: '100%' }} error={meta.error && meta.touched ? true : false}>
            {/* <FormLabel>{labelGroup}</FormLabel> */}
            {/* <Typography variant={'subtitle2'} className={classes.label}>
                {required && labelGroup ? labelGroup + '*' : labelGroup || ''}
            </Typography> */}
            {getLabel()}
            <RadioGroup
                row
                {...input}
                value={input.value}
                onChange={(evt) => {
                    input.onChange(evt.target.value)
                    if (onChangeValue) {
                        onChangeValue(evt.target.value)
                    }
                }}
            >
                {options.map((option, index) => (
                    <Fragment key={index}>
                        {/* <Grid item xs={12} md={6} lg={1}> */}
                        <FormControlLabel
                            key={`${option.id}a`}
                            label={<Typography variant={'body2'}> {option.name} </Typography>}
                            value={option.id}
                            control={
                                meta.error && meta.touched ? <ErrorRadio color="primary" /> : <Radio color="primary" />
                            }
                            disabled={disabled || option.disableOption}
                            style={option.style && { ...option.style }}
                        />

                        {option.icon && (
                            <IconButton
                                onClick={() => {
                                    if (option.onClickIcon) {
                                        option.onClickIcon(option.id)
                                    }
                                }}
                                style={{ padding: '0px' }}
                                // disabled={option.disableIcon}
                            >
                                {option.icon}
                            </IconButton>
                        )}
                        {/* </Grid> */}
                    </Fragment>
                ))}
            </RadioGroup>
            <FormHelperText className={classes.errorText}>{meta.error && meta.touched && meta.error}</FormHelperText>
        </FormControl>
    )
}

let MyRadio: React.FC<RadioCtrlProps> = ({ name, ...others }) => {
    const myRadio = useRadio({
        name,
        ...others,
    })
    return <MyRadioView {...myRadio} {...others} />
}

export default MyRadio

const useStyles = makeStyles((theme) => ({
    label: {
        marginBottom: 5,
        color: (isError: any) => {
            if (isError) {
                return '#ff4d4f'
            } else {
                return ''
            }
        },
    },
    errorText: {
        fontSize: '12px',
        color: '#ff4d4f',
    },
}))
